export function fixGoDate(date: Date, dateString: string | null | undefined): Date | null {
  if (dateString == null || dateString.startsWith('0001')) {
    return null;
  }

  return date;
}

export function fixGoSlice<T>(slice: T[] | null): T[] {
  if (slice === null) {
    return [];
  }

  return slice;
}
